<template>
  <div class="button_toTop" v-show="showUpButton && !curConfig.isPC" @click="goToTop">
    <img src="../../assets/images/btntotop.png" alt />
  </div>
</template>

<script>
export default {
  name: "goToTop",
  data() {
    return {
      scrollY: "",
      curConfig: {}
    };
  },
  computed: {
    // 置顶按钮切换
    showUpButton() {
      var clientHeight = document.documentElement.clientHeight;
      // console.log(this.scrollY, clientHeight);
      return this.scrollY > clientHeight / 2;
    }
  },
  methods: {
    goToTop() {
      window.scroll(0, 0);
    },
    handleScroll() {
      let scrollY = window.scrollY;
      this.scrollY = scrollY;
      //   console.log(this.scrollY);
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.onresize = () => {
      return (() => {
        window.screenClient = document.body.clientHeight;
        this.screenClient = window.clientHeight;
      })();
    };
    this.curConfig = this.$browser();
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="less" scoped>
.button_toTop {
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  //   background: #fff;
  border: none;
  border-radius: 50%;
  font-size: 10px;
  position: fixed;
  bottom: 78px;
  right: 13px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/operate/gototop.vue